//#region src/utils/manifest.ts
function matchRemoteWithNameAndExpose(remotes, id) {
    for (var remote of remotes){
        var isNameMatched = id.startsWith(remote.name);
        var expose = id.replace(remote.name, "");
        if (isNameMatched) {
            if (expose.startsWith("/")) {
                var pkgNameOrAlias = remote.name;
                expose = `.${expose}`;
                return {
                    pkgNameOrAlias,
                    expose,
                    remote
                };
            } else if (expose === "") return {
                pkgNameOrAlias: remote.name,
                expose: ".",
                remote
            };
        }
        var isAliasMatched = remote.alias && id.startsWith(remote.alias);
        var exposeWithAlias = remote.alias && id.replace(remote.alias, "");
        if (remote.alias && isAliasMatched) {
            if (exposeWithAlias && exposeWithAlias.startsWith("/")) {
                var pkgNameOrAlias1 = remote.alias;
                exposeWithAlias = `.${exposeWithAlias}`;
                return {
                    pkgNameOrAlias: pkgNameOrAlias1,
                    expose: exposeWithAlias,
                    remote
                };
            } else if (exposeWithAlias === "") return {
                pkgNameOrAlias: remote.alias,
                expose: ".",
                remote
            };
        }
    }
}
function matchRemote(remotes, nameOrAlias) {
    for (var remote of remotes){
        if (nameOrAlias === remote.name) return remote;
        if (remote.alias && nameOrAlias === remote.alias) return remote;
    }
}
//#endregion
exports.matchRemote = matchRemote;
exports.matchRemoteWithNameAndExpose = matchRemoteWithNameAndExpose; //# sourceMappingURL=manifest.cjs.map
